import * as shippingTypes from './shipping.type';

const initialState = {
  shippingPriceMultiplier: null,
  shippingPriceList: [],
  error: null,
  isLoading: false,
  visible: false,
};

const shippingReducer = (state = initialState, action) => {
  switch (action.type) {
    case `${shippingTypes.LIST_SHIPPING_PRICE_MULTIPLIER_REJECTED}`:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case `${shippingTypes.LIST_SHIPPING_PRICE_MULTIPLIER_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        error: null,
        shippingPriceList: action.payload,
      };
    case `${shippingTypes.LIST_SHIPPING_PRICE_MULTIPLIER_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case `${shippingTypes.GET_SHIPPING_PRICE_MULTIPLIER_PENDING}`:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case `${shippingTypes.GET_SHIPPING_PRICE_MULTIPLIER_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        error: null,
        shippingPriceMultiplier: action.payload,
      };
    case `${shippingTypes.GET_SHIPPING_PRICE_MULTIPLIER_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    case `${shippingTypes.UPDATE_SHIPPING_PRICE_MULTIPLIER_PENDING}`:
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case `${shippingTypes.UPDATE_SHIPPING_PRICE_MULTIPLIER_FULFILLED}`:
      return {
        ...state,
        isLoading: false,
        error: null,
        shippingPriceMultiplier: action.payload,
      };
    case `${shippingTypes.UPDATE_SHIPPING_PRICE_MULTIPLIER_REJECTED}`:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default shippingReducer;
